import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mergePullRequestAction: {
    id: 'frontbucket.repository.pullRequest.mergePullRequest',
    description: 'Action to merge a pull request',
    defaultMessage: 'Merge',
  },
  declinePullRequestAction: {
    id: 'frontbucket.repository.pullRequest.declinePullRequest',
    description: 'Action to decline a pull request',
    defaultMessage: 'Decline',
  },
  declineDialogTitle: {
    id: 'frontbucket.repository.pullRequest.declinePullRequestDialog',
    description: 'Title of decline dialog for a pull request',
    defaultMessage: 'Decline pull request',
  },
  declineDialogInfo: {
    id: 'frontbucket.repository.pullRequest.declineDialogInfo',
    description: 'Informational text inside the decline dialog',
    defaultMessage: 'Declining a pull request cannot be undone.',
  },
  declineDialogLabel: {
    id: 'frontbucket.repository.pullRequest.declineLabel',
    description: 'Label the decline dialog reason',
    defaultMessage: 'Why are you declining this pull request?',
  },
  declineErrorInfo: {
    id: 'frontbucket.repository.pullRequest.declineErrorInfo',
    description: 'Informational text inside the failed decline dialog box',
    defaultMessage: 'Unable to decline',
  },
  declineErrorMessage: {
    id: 'frontbucket.repository.pullRequest.declineErrorMessage',
    description: 'Error message for when decline api throws error',
    defaultMessage: 'Something went wrong. Wait a few moments, then try again.',
  },
  watchPullRequestAction: {
    id: 'frontbucket.repository.pullRequest.watchPullRequest',
    description: 'Action to watch a pull request',
    defaultMessage: 'Watch',
  },
  stopWatchingPullRequestAction: {
    id: 'frontbucket.repository.pullRequest.stopWatchingPullRequest',
    description: 'Action to stop watching a pull request',
    defaultMessage: 'Stop watching',
  },
  reviewersListLabel: {
    id: 'frontbucket.repository.pullRequest.reviewersListLabel',
    description: 'Label for list of reviewers',
    defaultMessage: 'Reviewers list',
  },
  newPrOptoutPermAction: {
    id: 'frontbucket.repository.pullRequest.newPrOptoutPermAction',
    description:
      'Action to permanently opt out of the new code review experience',
    defaultMessage: 'Turn off in Bitbucket Labs',
  },
  viewInVSCodeAction: {
    id: 'frontbucket.repository.pullRequest.viewInVSCode',
    description: 'A link to open a pull request in Visual Studio Code',
    defaultMessage: 'View in VS Code',
  },
  markAsDraftAction: {
    id: 'frontbucket.repository.pullRequest.markAsDraft',
    description: 'Action to mark a pull request as a draft',
    defaultMessage: 'Mark as draft',
  },
  markAsReadyAction: {
    id: 'frontbucket.repository.pullRequest.markAsReady',
    description: 'Action to mark a pull request as ready',
    defaultMessage: 'Mark as ready',
  },
  moreActionsLabel: {
    id: 'frontbucket.repository.pullRequest.moreActionsLabel',
    description: 'Aria label for more actions dropdown menu button',
    defaultMessage: 'More actions',
  },
  watchingFlagLabel: {
    id: 'frontbucket.repository.pullRequest.watchingFlagLabel',
    description: 'Label for now watching flag',
    defaultMessage: 'You are now watching this pull request.',
  },
  notWatchingFlagLabel: {
    id: 'frontbucket.repository.pullRequest.notWatchingFlagLabel',
    description: 'Label for not watching flag',
    defaultMessage: 'You are no longer watching this pull request.',
  },
  mergeInProgressMessage: {
    id: 'frontbucket.repository.pullRequest.mergeInProgressMessage',
    description:
      'Message that replaces request changes button when merge in progress',
    defaultMessage: 'Merge in Progress',
  },
});
